module.exports = "<app-card [infos]=\"infos\" (savedCard)=\"save($event)\"></app-card>"